import React from 'react';
import { ElementMetadataSectionName, IElementDataSectionRelatedDrillDown } from 'components/common/element-data/types';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import DrillDown from 'components/common/element-data/parts/DrillDown';
import useBundleTranslation from 'i18n';
import { getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function RelatedDrillDownSection(props: IElementDataSectionRelatedDrillDown) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { metricCompareValueUnit = '', settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'related_drill_down';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);

    return (
        <ElementDataSection
            adjustableDisplayTitle={false}
            title={t(`element_data_section_label.${sectionKey}`, { unit: metricCompareValueUnit })}
            order={sectionMetadataOrder}
        >
            <DrillDown {...element} settings={settings} />
        </ElementDataSection>
    );
}
